// extracted by mini-css-extract-plugin
export default {"btn-box":"style_btn-box__2tw9R","sign-button":"style_sign-button__mss5Z"};